/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-01 21:23:52
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 15:04:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCurrency/service/index.tsx
 */
import {
  currencies,
  getSalesChannelCurrency,
  getSymbol,
  saveSalesChannelCurrency,
} from '@/src/request/currency';
import { msg } from '@/src/tools/message';
import lodash from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { modal } from 'src/utils/Modal';
import {
  Cnversion,
  conversionOptions,
  DisplayFormat,
  SalesChannelCurrencyConfig,
} from '../constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

function useService(permissions) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const params: Record<string, any> = useParams();
  const { view_currency_setting } = permissions(params.uuid);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [primaryCuSymbol, setPrimary] = useState<Array<string>>([]);
  const [secondCuSymbol, setSecondary] = useState<Array<string>>([]);
  const [copy, setCopy] = useState({} as SalesChannelCurrencyConfig);
  const [currencyConfig, setCurrencyConfig] =
    useState<SalesChannelCurrencyConfig>({} as SalesChannelCurrencyConfig);

  useEffect(() => {
    if (view_currency_setting) {
      inner_initCurrencyConfig();
    }
  }, []);

  useEffect(() => {
    if (currencyConfig.currencyCode) {
      getSymbol(currencyConfig.currencyCode).then((res: Array<string>) => {
        const config = inner_updateConfig();
        setPrimary(res);
        setCurrencyConfig({
          ...config,
          currencySymbol: res && Array.isArray(res) ? res[0] : undefined,
        });
      });
    }
  }, [currencyConfig.currencyCode]);

  useEffect(() => {
    if (currencyConfig.secondaryCurrencyCode) {
      getSymbol(currencyConfig.secondaryCurrencyCode).then(
        (res: Array<string>) => {
          const config = inner_updateConfig();
          setSecondary(res);
          setCurrencyConfig({
            ...config,
            secondaryCurrencyDisplayFormat: DisplayFormat.PREFIX_AMOUNT,
            secondaryCurrencySymbol:
              res && Array.isArray(res) ? res[0] : undefined,
          });
        },
      );
    }
  }, [currencyConfig.secondaryCurrencyCode]);

  const navigateBack = () => {
    history.push(`/salesChannel/settings/${params.uuid}`);
  };

  const handleDiscard = () => {
    history.push(`/salesChannel/settings/${params.uuid}`);
  };

  const handleSubmit = () => {
    saveSalesChannelCurrency({
      ...currencyConfig,
      salesChannelUuid: params.uuid,
    }).then((res: any) => {
      setCopy(res);
      setCurrencyConfig(res);
      msg.success(getI18n('general.savesuccess'));
    });
  };

  const handleChangeCurrency = (value: any) => {
    if (
      currencyConfig.showSecondary &&
      currencyConfig.secondaryCurrencyCode === value.value
    ) {
      modal.info({
        title: getI18n('salesChannelCurrency.index.changePrimaryCurrency'),
        content: (
          <>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip1')}
            </div>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip2')}
            </div>
            <div style={{ marginTop: '15px' }}>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip3')}
            </div>
          </>
        ),
        onOkText: getI18n('general.confirm'),
        onCancelText: getI18n('general.cancel'),
        onOk: () => {
          setCurrencyConfig({
            ...currencyConfig,
            showSecondary: false,
            secondaryCurrencyCode: null,
            secondaryCurrencyName: null,
            secondaryCurrencyDisplayFormat: null,
            secondaryCurrencySymbol: null,
            currencyCode: value.value,
            currencyName: value.label,
          });
        },
        onCancel: () => {
          console.log('cancel');
        },
      });
    } else {
      modal.info({
        title: getI18n('salesChannelCurrency.index.changePrimaryCurrency'),
        content: (
          <>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip1')}
            </div>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip3')}
            </div>
          </>
        ),
        onOkText: getI18n('general.confirm'),
        onCancelText: getI18n('general.cancel'),
        onOk: () => {
          setCurrencyConfig({
            ...currencyConfig,
            currencyCode: value.value,
            currencyName: value.label,
          });
        },
        onCancel: () => {
          console.log('cancel');
        },
      });
    }
  };

  const handleChangeSecondCurrency = (value: any) => {
    setCurrencyConfig({
      ...currencyConfig,
      secondaryCurrencyCode: value.value,
      secondaryCurrencyName: value.label,
    });
  };

  const handleChangeShowSecond = (show: boolean) => {
    setCurrencyConfig({
      ...currencyConfig,
      showSecondary: show,
      secondaryCurrencyCode: show ? currencyConfig.secondaryCurrencyCode : null,
      secondaryCurrencyName: show ? currencyConfig.secondaryCurrencyName : null,
      secondaryCurrencyDisplayFormat: show
        ? currencyConfig.secondaryCurrencyDisplayFormat
        : null,
      secondaryCurrencySymbol: show
        ? currencyConfig.secondaryCurrencySymbol
        : null,
    });
  };

  const handleChangeDecimalPosition = (value: number) => {
    setCurrencyConfig({
      ...currencyConfig,
      decimalPosition: value,
    });
  };

  const handleChangePropsViaEvent = (prop: string, e: any) => {
    setCurrencyConfig({
      ...currencyConfig,
      [prop]: e.target.value,
    });
  };

  const handleChangePropsViaValue = (prop: string, value: any) => {
    setCurrencyConfig({
      ...currencyConfig,
      [prop]: value,
    });
  };

  const getOptions = (isPrimary: boolean) => {
    return isPrimary
      ? currencyOptions
      : currencyOptions.filter((c) => c.code !== currencyConfig.currencyCode);
  };

  const inner_initCurrencyConfig = async () => {
    const currencyOptions: any = await currencies();
    const config: any = await getSalesChannelCurrency(params.uuid);
    const reportingCurrency = Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {};
    setCurrencyConfig(inner_fillConfig(config, reportingCurrency));
    setCurrencyOptions(currencyOptions);
    setCopy(config);
  };

  const inner_fillConfig = (
    config: SalesChannelCurrencyConfig,
    reportingCurrency: any,
  ): SalesChannelCurrencyConfig => {
    if (config.uuid) {
      return config;
    } else {
      return {
        currencyCode: reportingCurrency.code,
        currencyName: `${reportingCurrency.label} - ${getI18n(
          'salesChannelCurrency.index.reportingcurrency',
        )}`,
        showSecondary: false,
        decimalPosition: 2,
        decimalSeparator: 'POINT',
        thousandsSeparator: 'NOT_USE',
        currencySymbol: undefined,
        currencyDisplayFormat: 'PREFIX_AMOUNT',
      };
    }
  };

  const inner_updateConfig = () => {
    const reportingCurrency = Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {};
    //drop down中的位数默认选中与decimal place 配置的一致 e.g. decimal place设置数字为2，round number down to “ Hundredths (2 decimals, cents)”
    if (
      reportingCurrency &&
      reportingCurrency.code &&
      (reportingCurrency.code !== currencyConfig.secondaryCurrencyCode ||
        reportingCurrency.code !== currencyConfig.currencyCode)
    ) {
      return {
        ...currencyConfig,
        conversionMode: currencyConfig.conversionMode
          ? currencyConfig.conversionMode
          : Cnversion.Round,
        roundingRule:
          currencyConfig.conversionMode === Cnversion.Round ||
          !currencyConfig.conversionMode
            ? currencyConfig.roundingRule
              ? currencyConfig.roundingRule
              : conversionOptions({ getI18n }).find(
                  (c) => c.index === currencyConfig.decimalPosition + 1,
                ).value
            : null,
      };
    } else {
      return currencyConfig;
    }
  };

  return {
    reportingCurrency: Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {},
    primaryCuSymbol,
    secondCuSymbol,
    currencyConfig,
    salesChannelUuid: params.uuid,
    saveDisabled: lodash.isEqual(copy, currencyConfig),
    getOptions,
    navigateBack,
    handleSubmit,
    handleDiscard,
    handleChangeCurrency,
    handleChangeShowSecond,
    handleChangeSecondCurrency,
    handleChangeDecimalPosition,
    handleChangePropsViaEvent,
    handleChangePropsViaValue,
  };
}

export default useService;
